import { OfferLabelIconType } from '@/types/offerWall';

interface Props {
  className?: string;
  icon: OfferLabelIconType;
}

const OfferWallIcon = ({ className, icon }: Props) => {
  switch (icon) {
    case 'pre-approved':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          className={className}
        >
          <circle cx="8" cy="8" r="8" fill="#609399" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.6495 5.26505C11.34 4.98986 10.8659 5.01774 10.5907 5.32733L7.11911 9.23282L5.68164 7.79526C5.38876 7.50236 4.91389 7.50235 4.62098 7.79523C4.32808 8.08811 4.32807 8.56299 4.62095 8.85589L6.62086 10.8559C6.76692 11.002 6.96675 11.0813 7.17322 11.0753C7.37969 11.0692 7.57453 10.9783 7.71176 10.8239L11.7118 6.32388C11.987 6.0143 11.9591 5.54024 11.6495 5.26505Z"
            fill="#F0F8F9"
          />
        </svg>
      );

    case 'filter':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          className={className}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.87469 13.4114L9.8738 13.4123L8.83602 12.3745L4.16602 7.70453L5.20379 6.66675L9.8738 11.3368L9.87469 11.3376L9.87559 11.3368L14.5456 6.66675L15.5834 7.70453L10.9134 12.3745L9.87559 13.4123L9.87469 13.4114Z"
            fill="#03292E"
          />
        </svg>
      );
    case 'collateral-required':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          className={className}
        >
          <g opacity="0.4" clipPath="url(#clip0_3892_5259)">
            <path
              d="M8 16C3.5816 16 0 12.4184 0 8C0 3.5816 3.5816 0 8 0C12.4184 0 16 3.5816 16 8C16 12.4184 12.4184 16 8 16ZM7.2 10.4V12H8.8V10.4H7.2ZM7.2 4V8.8H8.8V4H7.2Z"
              fill="#03292E"
            />
          </g>
          <defs>
            <clipPath id="clip0_3892_5259">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'heloc':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          className={className}
        >
          <g opacity="0.4">
            <path
              d="M14 7.49992V13.4999C14 13.6325 13.9473 13.7597 13.8536 13.8535C13.7598 13.9472 13.6326 13.9999 13.5 13.9999H2.50001C2.3674 13.9999 2.24022 13.9472 2.14645 13.8535C2.05268 13.7597 2.00001 13.6325 2.00001 13.4999V7.49992C1.99954 7.36845 2.02521 7.2382 2.07553 7.11674C2.12586 6.99528 2.19982 6.88503 2.29313 6.79242L7.29313 1.79242C7.48065 1.60502 7.7349 1.49976 8.00001 1.49976C8.26511 1.49976 8.51936 1.60502 8.70688 1.79242L13.7069 6.79242C13.8002 6.88503 13.8742 6.99528 13.9245 7.11674C13.9748 7.2382 14.0005 7.36845 14 7.49992Z"
              fill="#03292E"
            />
            <path
              d="M10.4563 7.14601L7.14757 10.8683L5.49329 9.21393"
              stroke="white"
              strokeWidth="0.872286"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </svg>
      );
    case 'line-of-credit':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          className={className}
        >
          <g opacity="0.4">
            <path
              d="M13.5 5.50006V12.5001C13.5 12.7653 13.3946 13.0196 13.2071 13.2072C13.0196 13.3947 12.7652 13.5001 12.5 13.5001H1.5C1.23478 13.5001 0.98043 13.3947 0.792893 13.2072C0.605357 13.0196 0.5 12.7653 0.5 12.5001V5.50006C0.5 5.23484 0.605357 4.98049 0.792893 4.79295C0.98043 4.60542 1.23478 4.50006 1.5 4.50006H12.5C12.7652 4.50006 13.0196 4.60542 13.2071 4.79295C13.3946 4.98049 13.5 5.23484 13.5 5.50006ZM14.5 2.50006H3C2.86739 2.50006 2.74021 2.55274 2.64645 2.64651C2.55268 2.74028 2.5 2.86745 2.5 3.00006C2.5 3.13267 2.55268 3.25985 2.64645 3.35361C2.74021 3.44738 2.86739 3.50006 3 3.50006H14.5V11.0001C14.5 11.1327 14.5527 11.2598 14.6464 11.3536C14.7402 11.4474 14.8674 11.5001 15 11.5001C15.1326 11.5001 15.2598 11.4474 15.3536 11.3536C15.4473 11.2598 15.5 11.1327 15.5 11.0001V3.50006C15.5 3.23484 15.3946 2.98049 15.2071 2.79295C15.0196 2.60542 14.7652 2.50006 14.5 2.50006Z"
              fill="#03292E"
            />
          </g>
        </svg>
      );
    case 'personal-loan':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          className={className}
        >
          <g opacity="0.4">
            <path
              d="M8 16C3.5816 16 0 12.4184 0 8C0 3.5816 3.5816 0 8 0C12.4184 0 16 3.5816 16 8C16 12.4184 12.4184 16 8 16ZM8.70711 5.31271C8.31658 4.92218 7.68342 4.92218 7.29289 5.31271L5.31271 7.29289C4.92218 7.68342 4.92218 8.31658 5.31271 8.70711L7.29289 10.6873C7.68342 11.0778 8.31658 11.0778 8.70711 10.6873L10.6873 8.70711C11.0778 8.31658 11.0778 7.68342 10.6873 7.29289L8.70711 5.31271Z"
              fill="#03292E"
            />
          </g>
        </svg>
      );
    case 'secured-loan':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          className={className}
        >
          <g opacity="0.4">
            <path
              d="M2.02356 1.328L7.99956 0L13.9756 1.328C14.1371 1.3639 14.2815 1.45379 14.385 1.58284C14.4885 1.71189 14.545 1.87238 14.545 2.03782V9.30109C14.545 10.0194 14.3676 10.7267 14.0286 11.36C13.6896 11.9933 13.1995 12.5332 12.6017 12.9316L7.99956 16L3.39737 12.9316C2.79975 12.5333 2.30971 11.9935 1.97072 11.3603C1.63173 10.7271 1.45427 10.02 1.4541 9.30182V2.03782C1.45413 1.87238 1.51057 1.71189 1.61409 1.58284C1.71762 1.45379 1.86206 1.3639 2.02356 1.328Z"
              fill="#03292E"
            />
            <path
              d="M11.3685 5.25012L7.09255 10.0605L4.95469 7.92253"
              stroke="white"
              strokeWidth="1.02622"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </svg>
      );
    case 'unsecured':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          className={className}
        >
          <g opacity="0.4">
            <path
              d="M2.02356 1.328L7.99956 0L13.9756 1.328C14.1371 1.3639 14.2815 1.45379 14.385 1.58284C14.4885 1.71189 14.545 1.87238 14.545 2.03782V9.30109C14.545 10.0194 14.3676 10.7267 14.0286 11.36C13.6896 11.9933 13.1995 12.5332 12.6017 12.9316L7.99956 16L3.39737 12.9316C2.79975 12.5333 2.30971 11.9935 1.97072 11.3603C1.63173 10.7271 1.45427 10.02 1.4541 9.30182V2.03782C1.45413 1.87238 1.51057 1.71189 1.61409 1.58284C1.71762 1.45379 1.86206 1.3639 2.02356 1.328Z"
              fill="#03292E"
            />
            <path
              d="M10.7499 4.75378L7.99993 7.50398L5.24962 4.75391"
              stroke="white"
              strokeWidth="1.02622"
              strokeLinecap="round"
            />
            <path
              d="M5.25012 10.254L8.00007 7.50384L10.7504 10.2539"
              stroke="white"
              strokeWidth="1.02622"
              strokeLinecap="round"
            />
          </g>
        </svg>
      );
    case 'consolidation':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g opacity="0.5" clipPath="url(#clip0_1588_16000)">
            <path
              d="M4.4974 1.66406C4.86948 1.66406 5.23791 1.73735 5.58167 1.87974C5.92542 2.02213 6.23777 2.23083 6.50087 2.49393C6.76397 2.75703 6.97267 3.06937 7.11506 3.41313C7.25744 3.75688 7.33073 4.12532 7.33073 4.4974V7.33073H4.4974C3.74595 7.33073 3.02528 7.03222 2.49393 6.50087C1.96257 5.96951 1.66406 5.24884 1.66406 4.4974C1.66406 3.74595 1.96257 3.02528 2.49393 2.49393C3.02528 1.96257 3.74595 1.66406 4.4974 1.66406ZM4.4974 8.66406H7.33073V11.4974C7.33073 12.0578 7.16456 12.6056 6.85323 13.0715C6.5419 13.5375 6.09939 13.9006 5.58167 14.1151C5.06394 14.3295 4.49425 14.3856 3.94464 14.2763C3.39503 14.167 2.89018 13.8971 2.49393 13.5009C2.09768 13.1046 1.82783 12.5998 1.71851 12.0502C1.60918 11.5005 1.66529 10.9309 1.87974 10.4131C2.09419 9.8954 2.45734 9.4529 2.92328 9.14157C3.38922 8.83024 3.93702 8.66406 4.4974 8.66406ZM11.4974 1.66406C12.2488 1.66406 12.9695 1.96257 13.5009 2.49393C14.0322 3.02528 14.3307 3.74595 14.3307 4.4974C14.3307 5.24884 14.0322 5.96951 13.5009 6.50087C12.9695 7.03222 12.2488 7.33073 11.4974 7.33073H8.66406V4.4974C8.66406 3.74595 8.96257 3.02528 9.49393 2.49393C10.0253 1.96257 10.746 1.66406 11.4974 1.66406ZM8.66406 8.66406H11.4974C12.0578 8.66406 12.6056 8.83024 13.0715 9.14157C13.5375 9.4529 13.9006 9.8954 14.1151 10.4131C14.3295 10.9309 14.3856 11.5005 14.2763 12.0502C14.167 12.5998 13.8971 13.1046 13.5009 13.5009C13.1046 13.8971 12.5998 14.167 12.0502 14.2763C11.5005 14.3856 10.9309 14.3295 10.4131 14.1151C9.8954 13.9006 9.4529 13.5375 9.14157 13.0715C8.83024 12.6056 8.66406 12.0578 8.66406 11.4974V8.66406Z"
              fill="#03292E"
            />
          </g>
          <defs>
            <clipPath id="clip0_1588_16000">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    default:
      return null;
  }
};

export default OfferWallIcon;
